import io from 'socket.io-client'
import { apiUrl } from './cutileiApi'
import { reportError } from './errorReporting'

export const SocketRoom = {
  business:     id => `business:${id}`,
  cashRegister: id => `cash_register:${id}`,
  company:      id => `company:${id}`,
  member:       id => `member:${id}`,
  // As conversas do WhatsApp do salão: salão, admin e profissional com a permissão `whatsapp`
  whatsapp:     id => `whatsapp:${id}`
}

/**
 * Abre um socket já inscrito nas salas pedidas.
 *
 * Antes cada tela chamava `io (apiUrl)` direto, sem credencial nenhuma, e o servidor
 * mandava todo evento em broadcast — qualquer cliente anônimo escutava o caixa e a agenda
 * de todos os salões. Agora o servidor só entrega o que a sala permite, e a sala só é
 * concedida contra o token.
 *
 * A inscrição vai dentro do `connect`, e não uma vez só depois de conectar: sala é estado
 * de conexão, então ao reconectar o socket volta sem nenhuma e precisa se reinscrever —
 * caso contrário a tela fica muda depois da primeira queda de rede.
 */
export function connectSocket ({ token, rooms }) {
  const socket = io (apiUrl)

  socket.on ('connect', () => {
    socket.emit ('subscribe', { token, rooms }, response => {
      const granted = response?.rooms?.length ?? 0

      // Falha silenciosa aqui é uma tela que simplesmente para de atualizar, sem erro
      // visível: por isso vira evento em vez de log.
      if (response?.error) reportError (
        new Error (`Socket recusou a inscrição: ${response.error}`), { context: 'socket' }
      )
      else if (granted < rooms.length) reportError (
        new Error (`Socket concedeu ${granted} de ${rooms.length} salas`), { context: 'socket' }
      )
    })
  })

  return socket
}
